import { Type } from 'class-transformer';

export class CalendarYearStatContractRes {
    userId!: number;
    year!: number;

    currentIsoWeek!: number;
    currentIsoYear!: number;

    weeklyTargetHours!: number;
    workdaysPerWeek!: number;
    targetHoursPerDay!: number;

    vacationDaysEntitlement!: number;
    vacationDaysTaken!: number;
    vacationDaysRemaining!: number;
    vacationDaysRemainingRaw!: number;

    vacationDaysPlanned!: number;
    vacationDaysPlannedApproved!: number;
    vacationDaysPlannedPending!: number;

    totalWorkedHoursYear!: number;
    currentOvertimeHours!: number;
    currentOvertimeHoursRaw!: number;
    totalOvertimeHoursYear!: number;

    publicHolidayDaysCount!: number;
    possibleWorkingDaysCountYear!: number;
    sickDays!: number;

    @Type(() => CalendarTimePolicyBalanceContractRes)
    timePolicyBalance!: CalendarTimePolicyBalanceContractRes;

    @Type(() => CalendarWeekStatContractRes)
    weeks: CalendarWeekStatContractRes[] = [];
}

export class CalendarTimePolicyBalanceContractRes {
    userId!: number;
    year!: number;

    @Type(() => Date)
    asOfUtc!: Date;

    @Type(() => CalendarVacationTimePolicyBalanceContractRes)
    vacation!: CalendarVacationTimePolicyBalanceContractRes;

    @Type(() => CalendarOvertimeTimePolicyBalanceContractRes)
    overtime!: CalendarOvertimeTimePolicyBalanceContractRes;
}

export class CalendarVacationTimePolicyBalanceContractRes {
    entitlementDaysCurrentYear!: number;

    carryOverDaysFromPreviousYear!: number;
    carryOverDaysUsedApproved!: number;
    carryOverDaysUsedPending!: number;
    carryOverDaysExpired!: number;
    carryOverDaysRemaining!: number;

    currentYearDaysUsedApprovedOrTaken!: number;
    currentYearDaysPlannedPending!: number;

    availableDaysNow!: number;
    eligibleCarryOverDaysAtYearEnd!: number;

    @Type(() => Date)
    carryOverDeadlineUtc?: Date | null;
}

export class CalendarOvertimeTimePolicyBalanceContractRes {
    rawCurrentOvertimeHours!: number;
    rawYearOvertimeHours!: number;

    carryOverHoursFromPreviousYear!: number;
    carryOverHoursUsedApproved!: number;
    carryOverHoursUsedPending!: number;
    carryOverHoursExpired!: number;
    carryOverHoursRemaining!: number;

    availableHoursNow!: number;
    eligibleCarryOverHoursAtYearEnd!: number;

    @Type(() => Date)
    carryOverDeadlineUtc?: Date | null;
}

export class CalendarWeekStatContractRes {
    isoWeek!: number;

    @Type(() => Date)
    weekStartUtc!: Date;

    @Type(() => Date)
    weekEndUtc!: Date;

    expectedHours!: number;
    workedHours!: number;
    absenceCreditHours!: number;
    overtimeHours!: number;
    remainingHours!: number;

    overtimeBalanceBeforeWeek!: number;
    adjustedExpectedHours!: number;

    publicHolidayDaysCount!: number;
    possibleWorkingDaysCount!: number;
    sickDays!: number;
}

export class CalendarStatsQueryReq {
    userId?: number;
    year?: number;

    constructor(val: Partial<CalendarStatsQueryReq>) {
        Object.assign(this, val);
    }
}